<template>
  <styledLinkrapper
    :hoverColor="currentTheme().select_color"
    class="archive-link-modul"
  >
    <WpLink class="link-archive" :url="link">
      <span class="text"><slot></slot></span>
      <StyledIcon class="icon" v-html="svgIcons.arrow2" />
    </WpLink>
  </styledLinkrapper>
</template>

<script>
import StyledIcon from "@/components/elements/StyledIcon";
import WpLink from "@/components/elements/WpLink";

import styled from "vue-styled-components";

const wrapperProps = { hoverColor: String };
const styledLinkrapper = styled("div", wrapperProps)`
  ${props =>
    props.hoverColor && props.hoverColor !== ""
      ? "a:hover{ color: " + props.hoverColor + "}"
      : ""};
`;
export default {
  name: "archive-link",
  props: ["type"],
  computed: {
    link() {
      const PostTypes = window.WPVUE.post_types;
      const Home = window.WPVUE.home_url;
      let to = "/";
      switch (this.type) {
        case "post":
          to = PostTypes.post.rewrite;
          break;
        case "events":
          to = PostTypes.events.rewrite;
          break;
        case "help":
          to = PostTypes.help.rewrite;
          break;
        case "inspirasjon":
          to = PostTypes.inspirasjon.rewrite;
          break;
        case "aktiviteter":
          to = PostTypes.aktiviteter.rewrite;
          break;
        case "video":
          // videos are listed on the inspirasjon archive
          to = PostTypes.inspirasjon.rewrite;
          break;
      }

      return Home + "/" + to;
    }
  },
  components: {
    StyledIcon,
    WpLink,
    styledLinkrapper
  }
};
</script>

<style lang="scss">
.archive-link-modul {
  font-size: 16px;
  font-weight: 700;
  margin-left: 20px;
  .link-archive {
    color: inherit;
    text-decoration: none;
  }
  .text {
  }
  .icon {
    margin-left: 10px;
    display: inline-block;
    position: relative;
    top: 1px;
    svg {
      height: 15px;
    }
  }
}
</style>
